export default `
    <a class="pane-body-icon-container link pointer hover-image-container #= data.classes # #=data.bsc||""#"
        # if (data.disabled) { # disabled # } # id="#= data.id #"
        # if (data.toolTip) { # title="#= data.toolTip #" # } #
        # if (data.href) { # href="#= data.href #" # } #
    >
        <span data-label-for-id="#= data.id #" class="icon-label bind-label" data-bind="#= data.bindLabel #">
        </span>
    </a>
`;
